import { toast } from 'sonner';
import { startTransition } from 'react';
import { useMutation } from '@apollo/client/react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { EscrowMemberRoleEnum } from 'src/graphql/schema';
import { EscrowMemberUpdateDocument } from 'src/graphql/actions/escrowMembers/escrowMemberUpdate.mutation';

import { roleOptions, roleOptionsDict } from '../model/roleOptions';
import { refetchEscrowMembers } from '../api';

const RoleCell = ({ role, id, canUpdate }: { role: string; id: string; canUpdate: boolean }) => {
  const [updateEscrowMember, { loading }] = useMutation(EscrowMemberUpdateDocument);

  const onUpdate = async (role: EscrowMemberRoleEnum) => {
    try {
      await updateEscrowMember({
        variables: {
          input: {
            escrowMemberId: id,
            escrowMemberParams: {
              role,
            },
          },
        },
      });
      toast.success('Member access has been updated');
      startTransition(() => refetchEscrowMembers());
    } catch (error) {
      toast.error('Failed to update member access');
    }
  };

  if (canUpdate) {
    return (
      <Select value={role} onValueChange={onUpdate}>
        <SelectTrigger variant="ghost" justify="end" disabled={loading} className="px-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {roleOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return roleOptionsDict[role as EscrowMemberRoleEnum];
};

export default RoleCell;
